export const isHeadless = /HeadlessChrome/.test(navigator.userAgent);
